export default function hashGenerator(array: any[], key: string | number) {
  const hash: any = {};
  array.forEach((elem, index) => {
    if (!hash[elem[key]]) {
      hash[elem[key]] = { ...elem, index };
    }
  });
  return hash;
}
